import { Pipe, PipeTransform } from '@angular/core';
import { BackendMessageTranslatorService } from '../services/backend-message-translator.service';

/**
 * Pipe that translates backend messages from Spanish to English
 * when the app language is set to English.
 *
 * Usage in templates:
 *   {{ errorMessage | translateBackendMsg }}
 *   {{ viewModel.error | translateBackendMsg }}
 *
 * When language is Spanish (default) – the original message is returned unchanged.
 * When language is English – the translated message is returned (if a mapping exists).
 */
@Pipe({
  name: 'translateBackendMsg',
  pure: false, // re-evaluates when language changes at runtime
})
export class TranslateBackendMsgPipe implements PipeTransform {
  constructor(private readonly translator: BackendMessageTranslatorService) {}

  transform(message: string | null | undefined): string {
    return this.translator.translate(message);
  }
}
